(ns minorodata.components.login.core
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]))

(defn login-callback []
  (reagent/create-class
    {:display-name "login-callback"

     :constructor
     (fn [] )

     :render
     (fn [] [:div])}))

(defn forbidden []
  (reagent/create-class
    {:display-name "forbidden"

     :constructor
     (fn []
       ;; don't allow non-restricted users to navigate to the forbidden page
       (let [user @(re-posh/subscribe [:user/pull])]
         (when-not (-> user :user/roles first (= "restricted"))
           (re-frame/dispatch [:app.events/navigate :connections]))))

     :render
     (fn []
       [:div
        {:class "top-1/2 relative text-center"}
        "Sorry, you don’t currently have access, please contact your Kleene Admin."])}))
